import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const RSY10 = lazy(() => import('@/pages/C01/RSY10')); // 코드관리
const RSY11 = lazy(() => import('@/pages/C01/RSY11')); // 사용자관리
const RSY12 = lazy(() => import('@/pages/C01/RSY12')); // 업체관리
const RSY44 = lazy(() => import('@/pages/C02/RSY44'));

function C01() {
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route path="/C01/RSY10" component={RSY10} />
        <Route path="/C01/RSY11" component={RSY11} />
        <Route path="/C01/RSY12" component={RSY12} />
        <Route path="/C02/RSY44" component={RSY44} />
      </Switch>
    </Suspense>
  );
}

export default C01;
